var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata-com"},[_c('div',{style:({'paddingTop':_vm.Top})},[_c('img',{attrs:{"src":_vm.nodata_img,"alt":"","width":_vm.ws,"height":_vm.hs}})]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.nodata_ind)))]),_vm._v(" "),_c('span',[_c('br'),_vm._v(_vm._s(_vm.$t( _vm.nodataTow)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d0db52e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/build902/components/NoData/index.vue
// module id = null
// module chunks = 